<template>
  <div id="app">
    <v-app>
    <transition :name="transitionName" mode="out-in" :enter-active-class="enter" :leave-active-class="leave">
      <component :is="layout" :isTouch="isTouch">
        <router-view :key="$route.fullPath"></router-view>
      </component>
    </transition>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const defaultLayout = 'guest'
export default {
  name: 'app',
  data () {
    return {
      windowWidth: '',
      transitionName: 'fade',
      enter: null,
      leave: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.transition || !this.transitionName) {
        this.transitionName = to.meta.transition
        this.transitionName = to.meta.enter
        this.transitionName = to.meta.leave
      } else {
        this.transitionName = 'fade'
        this.enter = null
        this.leave = null
      }
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    },
    isTouch: function () {
      if (this.windowWidth <= 960) {
        return true
      } return false
    }
  }
}
</script>

<style src="./styles/app.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue